module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-655530a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/Users.vue
// module id = 218
// module chunks = 1